import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { Paragraph as s } from "../../atoms/Paragraph/Paragraph.es.js";
import { useMultiStyleConfig as o, chakra as c } from "@chakra-ui/react";
const m = ({ numberOfItems: i }) => {
  const e = o("FloatingBottomMultiselectActions");
  return /* @__PURE__ */ l(c.div, { __css: e.selectedItemsContainer, "data-testid": "selected-items-container", children: [
    /* @__PURE__ */ t(s, { size: "lg", as: "span", sx: e.selectedItems, children: i }),
    /* @__PURE__ */ t(s, { sx: e.selectedItemsText, size: "sm", as: "span", children: "Selected" })
  ] });
};
export {
  m as FloatingBottomMultiselectItemsSelected
};
//# sourceMappingURL=FloatingBottomMultiselectItemsSelected.es.js.map
